import { render, staticRenderFns } from "./winning-dialog.vue?vue&type=template&id=168e3dcd&scoped=true&lang=pug&"
import script from "./winning-dialog.vue?vue&type=script&lang=js&"
export * from "./winning-dialog.vue?vue&type=script&lang=js&"
import style0 from "./winning-dialog.vue?vue&type=style&index=0&id=168e3dcd&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168e3dcd",
  null
  
)

export default component.exports